import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-more-product',
  templateUrl: './more-product.component.html',
  styleUrls: ['./more-product.component.css']
})
export class MoreProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/more-product/more-product.component.ts